/*
 * 团队模块API
 */

import { post, get, put, del } from 'api/http'
import storage from 'src/unit/storage'

export default {
    // 首页-获取用户状态
    getUserState(data) {
        // return get('/app/staff/team', data)
        return get('/wx/employee/findStaffState', data, 'javaHost')
    },

    // 搜索团队或组织
    getTeamMessage(data) {
        // return get('/app/staff', data)
        return post('/wx/employee/findStaff', data, 'javaHost')
    },

    // 申请加入
    applyJoin(data) {
        // return post('/app/staff', data)
        return post('/wx/employee/applyStaffMember', data, 'javaHost')
    },

    // 取消申请
    cancleApply(data) {
        // return del('/app/staff/apply/member', data)
        return get('/wx/employee/cancelApplyStaff', data, 'javaHost')
    },

    // 申请人员列表
    applyUserList(data) {
        // return get('/app/staff/apply/member', data)
        return post('/wx/employee/findStaffApplyMember', data, 'javaHost')
    },

    // 人员列表
    getStaffMemberList(data) {
        // return get('/app/staff/member', data)
        return post('/wx/employee/findStaffMemberList', data, 'javaHost')
    },

    // 审核申请-接受
    auditApply(data) {
        // return post('/app/staff/apply/member', data)
        return get('/wx/employee/acceptStaffMember', data, 'javaHost')
    },

    // 审核申请-拒绝、删除
    // deleteApply(data) {
    //     return del('/app/staff/apply/member', data)
    // },

    // 获取维保人员信息
    getStaffDetail(data) {
        // return get('/app/staff/member', data)
        return get('/wx/employee/findStaffMemberDetail', data, 'javaHost')
    },

    // 团队负责人创建用户时，检测手机号码是否存在
    checkUser(data) {
        // return get('/app/staff/check/user', data)
        return post('/wx/employee/findEmployeeDetail', data, 'javaHost')
    },

    // 创建人员账户
    registerUser(data) {
        // return post('/app/staff/check/user', data)
        return post('/contract/authorization/user', data, 'javaHost')
    },

    // 邀请加入团队
    inviteJoinTeam(data) {
        // return post('/app/staff/member', data)
        return get('/wx/employee/addStaffMember', data, 'javaHost')
    },

    // 移除成员
    delStaff(data) {
        // return del('/app/staff/member', data)
        return get('/wx/employee/deleteStaffMember', data, 'javaHost')
    },

    // 获取团队列表
    getTeamList(data) {
        // return get('/app/team', data)
        return post('/wx/employee/findStaffList', data, 'javaHost')
    },

    // 退出团队
    leaveTeam(data) {
        // return del('/app/staff/team', data)
        return get('/wx/employee/exitStaff', data, 'javaHost')
    },




    // 获取团队信息
    getTeamMsg(data) {
        // return post('staff/team_brief', data)
        return get('/app/staff/team', data)
    },

    // 申请加入团队
    applyJoinTeam(data) {
        // return post('staff/apply_join_bm', data)
        return post('/app/staff/apply', data)
    },

    // 人员详情
    getTeamDetail(data) {
        // return get('/app/staff/member', data)
        return get('/wx/employee/findStaffMemberDetail', data, 'javaHost')
    },

    // 更新人员工作信息
    updateTeam(data) {
        // return put('/app/staff/member', data)
        return post('/wx/employee/editStaffMember', data, 'javaHost')
    },

    // // 工程主管下的商务经理列表
    // getBmList(data) {
    //     // return get('/bm/query', data)
    //     return get('/app/staff/bm', data)
    // },

    // 修改团队名称
    updateTeamName(data) {
        // return put('/app/staff/team', data)
        return post('/wx/employee/editStaffName', data, 'javaHost')
    },

    // // 检查人员参与的所有项目
    // checkMemberProject(data) {
    //     // return get('/staff/contract', data)
    //     return get('/staff/contract', data)
    // },

    // // 项目授权
    // teamAuth(data) {
    //     // return post('bm/team_auth', data)
    //     return post('/app/staff/apply/auth', data)
    // },
}



// WEBPACK FOOTER //
// ./src/api/modules/ems/team.js